module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "flex middle-xs justify-center"
  }, [(_vm.loading_wordcloud) ? _c('pl-spinner', {
    staticClass: "x4"
  }) : (!_vm.show_cloud_svg && !_vm.loading_wordcloud) ? _c('img', {
    staticClass: "empty-cloud",
    attrs: {
      "src": "/static/cloud_empty.png",
      "alt": "word cloud"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show_cloud_svg && !_vm.loading_wordcloud),
      expression: "show_cloud_svg && !loading_wordcloud"
    }],
    staticClass: "wordcloud-container"
  }, [_c('div', {
    staticStyle: {
      "max-width": "700px"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.svg_data)
    }
  })]), _vm._v(" "), (!_vm.loading_wordcloud) ? _c('pl-button', {
    staticClass: "pl-icon",
    nativeOn: {
      "click": function($event) {
        _vm.show_info = true
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-info-circle"
  })]) : _vm._e(), _vm._v(" "), (_vm.show_info) ? _c('pl-dialog', {
    attrs: {
      "header": "The Idea Cloud analyzes the RoundTable for frequent words across\n      student submissions."
    },
    on: {
      "close": function($event) {
        _vm.show_info = false
      }
    }
  }, [_c('p', {
    staticClass: "italics pl-subheading tc"
  }, [_vm._v("\n        The bigger the word in the cloud, the more times it was used!\n      ")]), _vm._v(" "), (_vm.hasTeacherPermissionsInCourse) ? _c('section', {
    staticClass: "flex justify-center items-center ma3"
  }, [_c('p', {
    staticClass: "mr3 pl-caption"
  }, [_vm._v("\n          Share this visual and become a\n          "), _c('b', {
    staticClass: "link-to-blog",
    on: {
      "click": _vm.toBlogPost
    }
  }, [_vm._v("Parlay Trailblazer!")])]), _vm._v(" "), (_vm.show_cloud_svg) ? [_c('img', {
    staticClass: "social-icons clickable",
    attrs: {
      "src": "/static/shareOnTW.svg"
    },
    on: {
      "click": _vm.shareOnTW
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "social-icons clickable",
    attrs: {
      "src": "/static/shareOnFB.svg"
    },
    on: {
      "click": _vm.shareOnFB
    }
  })] : [_c('img', {
    staticClass: "social-icons",
    attrs: {
      "src": "/static/shareOnTW_disabled.svg"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "social-icons",
    attrs: {
      "src": "/static/shareOnFB_disabled.svg"
    }
  })]], 2) : _vm._e(), _vm._v(" "), _c('pl-button', {
    staticClass: "pl-primary",
    nativeOn: {
      "click": function($event) {
        _vm.show_info = false
      }
    }
  }, [_vm._v("\n        OK\n      ")])], 1) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-643be322!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/onlineRoundtables/components/roundtableSummary/roundtableSummaryWordCloud.vue
// module id = 1222
// module chunks = 61